import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { message } from "antd";
import "assets/css/demo.css"
import MyContext from "MyContext";
import { BsArrowLeftShort } from "react-icons/bs"
// import BiddingCard from "./BiddingCard";
import Profile from "assets/img/default-avatar.png"
import { useLocation } from "react-router-dom";
import Master from "./Masterss";

import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import moment from 'moment';

import { Collapse } from "antd";
const { Panel } = Collapse;

import ReactPaginate from 'react-paginate';
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form
} from "react-bootstrap";
import MasterProject from "./MasterProject";


const Projectdetailsss = () => {
  const { endPointUrl, Token } = useContext(MyContext);

  const [items, setitems] = useState({});
  const [detailview, setdetailview] = useState(false);
  const [user, setuser] = useState({});
  const location = useLocation();
  const [bidder, setbidder] = useState({});
  const [milestone, setmilestone] = useState([]);

  const Id = location.pathname.split('/').pop();

  const Projects = async (Id) => {
    console.log(Id);
    try {
      const { data } = await axios.post(endPointUrl + "/admin/getEmployerProjectdetails", {
        P_ID: Id,
        Token,
      });
      setitems(data.projectInfo);
      setuser(data.projectInfo.employers);
      setbidder(data.projectInfo.freelancers);
      if (data.projectInfo.Proj.length !== 0) {
        setmilestone(data.projectInfo.Proj);
      }

      console.log(data.projectInfo.Proj);
      // console.log(data.projectInfo);
    } catch {
      console.log("get all details projects is not working");
    }
  };

  useEffect(() => {
    Projects(Id);
  }, []);

  const Ongoing = items?.Project_status === "in_Progress";
  const Closed = items?.Project_status === "closed";
  console.log(items)


  return (
    <>
      <Container fluid>
        <div className="container-fluid d-flex justify-content-between">
          <h6 className="heading-6" style={{ padding: "20px 0 20px 0" }}>Project Details </h6>
        </div>
        <Row>
          <Col md="8">
            {/* <Card className="`card-user`">
              <Card.Header style={{backgroundColor:'#07b274'}}>
                <Card.Title as="h4">{items?.jobs?.Title}</Card.Title>
              <hr></hr>
              </Card.Header> */}
            <Card className='card-user' style={{ margin: "2% auto", padding: "20px", border: "1px solid #888" }}>

              <Card.Header style={{ backgroundColor: '#07b274' }}>
                <Card.Title as="h4">{items?.jobs?.Title}</Card.Title>
                <hr></hr>
              </Card.Header>
              <Card.Body>

                <div className="about">
                  <span>{items?.jobs?.ShortDesc}</span>
                </div>
                <hr></hr>
                <div className="about">
                  <h6>Detail Description</h6>
                  <span dangerouslySetInnerHTML={{ __html: items?.jobs?.Description }}></span>
                </div>
              </Card.Body>
            </Card>


            <Card className="card-user " style={{ margin: "2% auto", padding: "40px", border: "1px solid #888" }}>

              <div className="biddiv" >
                {/* <div style={{flex:'1'}} className="card-image profile">
           
            
             */}
                {/* </div> */}
                <div className="job-name" style={{ flex: '5', fontWeight: '600', fontSize: '30px', padding: "30px" }}>
                  <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <img
                      style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                      src={
                        bidder?.Photo === "" || bidder?.Photo == null
                          ? Profile
                          : `${endPointUrl}/images/${bidder?.Photo}`
                      }
                      alt="profile" />
                    <p className="fw-bold m-0">{bidder.Name}</p>
                  </span>

                  <div className="current-tags">
                    {(bidder?.Skills ? bidder.Skills.split(",") : []).map((val, index) => {
                      if (index < 3) {
                        return val.length > 0 ? <span>{val}</span> : null
                      }
                    })}
                    {(bidder?.Skills ? bidder.Skills.split(",") : []).length > 3 ? "+" : ""}
                    {(bidder?.Skills ? bidder.Skills.split(",") : []).length > 3 ? (bidder?.Skills ? bidder.Skills.split(",") : []).length - 3 : ""}

                  </div>
                </div>
                <div className="biddingInformation" style={{ flex: '2' }}>
                  <div id="bidheadStatus">
                    {Ongoing && (
                      <div>
                        <p>Ongoing</p>
                      </div>
                    )}
                    {Closed && (
                      <div>
                        <p>Closed</p>
                      </div>
                    )}
                  </div>

                  <div>
                    <span className="bidhead">Price</span>
                    <span id="bidheadValue">${items?.bid?.BidAmount}</span>
                  </div>
                  <div>
                    <span className="bidhead">Duration</span>
                    <span id="bidheadDuration">
                      {items?.bid?.Duration + " "}
                      {items?.bid?.DurationType === "Weekly" ? "Week" : "Month"}
                    </span>
                  </div>
                </div>


              </div>
              <b style={{ marginTop: "10px" }}>Proposal</b>
              <span dangerouslySetInnerHTML={{ __html: items?.bid?.Proposal }} className="biddingProposal"></span>
              <MasterProject milestone={milestone} />

              <div style={{ display: 'flex', gap: '5px', fontSize: "12px", verticalAlign: "top" }}>
                <div style={{ display: 'flex', gap: '5px' }}>
                  <div style={{ display: 'flex', width: "20px", height: '15px', background: "#b1f054" }}></div>Approved
                </div>

                <div style={{ display: 'flex', gap: '5px' }}>
                  <div style={{ display: 'flex', width: "20px", height: '15px', background: "#f2c12e" }}></div>Pending
                </div>

                <div style={{ display: 'flex', gap: '5px' }}>
                  <div style={{ display: 'flex', width: "20px", height: '15px', background: "#f5e449" }}></div>Up for review
                </div>
              </div>
            </Card>
          </Col >
          <Col md="4" style={{ marginTop: "15px" }}>
            <div className="compo2">
              <div className="profileConatiner">
                <div className="profile-details">

                  <img
                    src={
                      user?.Photo === "" || user?.Photo == null
                        ? Profile
                        : `${endPointUrl}/images/${user?.Photo}`
                    }
                    alt=""
                  // style={{width:'20%',display:"flex"}}
                  />
                  <span className="profilename">{user?.Name}</span>
                  <span className="profileDesignation">
                    {user?.Company}
                  </span>
                </div>
              </div>


              {/* <div className="row-view"> */}
              <div className="skillsset-card" style={{ marginTop: "10px" }}>
                <h5>Budget Details</h5>
                <small>
                  <span>${items?.jobs?.Budget_From}-</span>
                  <span>${items?.jobs?.Budget_To}</span>
                  {/* <span>{items?.jobs?.Budget_Type}</span> */}
                </small>
              </div>
              <hr style={{ width: "100%", background: "" }} />
              <div className="skillsset-card">
                {" "}
                <h5>Job Type</h5>
                <small>{items?.jobs?.Type}</small>
              </div>
              <hr style={{ width: "100%", background: "" }} />

              <div className="skillsset-card">
                {" "}
                <h5>Project Type</h5>
                <small>{items?.jobs?.ProjectType}</small>
              </div>
              <hr style={{ width: "100%", background: "" }} />

              <div className="skillsset-card" >

                <h5>Finance</h5>
                <ul>
                  <li>Paid Amount : ${items?.paidPayment}</li>
                  <li>Due Amount : ${items?.duePayment}</li>
                  <li>Total Amount : ${items?.TotalPayment}</li>
                </ul>
              </div>

              <hr style={{ width: "100%", background: "" }} />
              <div className="skillsset-card">
                {" "}
                <h5>Skills</h5>
                <div className="skillview">
                  {((items?.jobs?.SkillsRequired) ? items?.jobs?.SkillsRequired : '').split(",")?.map((item) => (
                    <span>{item}</span>
                  ))}
                </div>
              </div>
              <div className="skillsset-card">
                <h5>Technology</h5>
                <div className="skillview">
                  {((items?.jobs?.Technology) ? items?.jobs?.Technology : '').split(",").map((item) => (
                    <span>{item}</span>
                  ))}
                </div>
              </div>
              <div className="skillsset-card">
                <h5>Category</h5>
                <div className="skillview">
                  {((items?.jobs?.Category) ? items?.jobs?.Category : '').split(",").map((item) => (
                    <span>{item}</span>
                  ))}
                </div>
              </div>
              <div className="skillsset-card">
                <h5>Language</h5>
                <div className="skillview">
                  {((items?.jobs?.Language) ? items?.jobs?.Language : '').split(",").map((item) => (
                    <span>{item}</span>
                  ))}
                </div>
              </div>
              <div className="skillsset-card">
                <h5>KeyWords</h5>
                <div className="skillview" style={{ marginBottom: "20px" }}>
                  {(items?.jobs?.Keywords)?.split(",").map((item) => (
                    <span>{item}</span>
                  ))}
                </div>
              </div>
            </div>



            {/* </Card> */}
          </Col>
        </Row>
      </Container>

    </>
  )
}

export default Projectdetailsss;